import React, { useEffect, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { sendPasswordResetCode } from '@App/api/routes/user'
import { observer } from 'mobx-react'
import ChangePasswordStep from '@Scenes/ForgotPasswordScene/ChangePasswordStep'
import { NavLink } from 'react-router'
import { ICONS } from '@Const/common'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const ChangePasswordScene = () => {
    const [hasBeenUpdated, setHasBeenUpdated] = useState<boolean>(false)

    useEffect(() => {
        analyticsSendPage('change_password')
        sendPasswordResetCode().then()
    }, [])

    return (
        <>
            <title>Change password</title>
            <main className="change-password-scene">
                <NavLink to="/profile" className="close-wrapper">
                    <img src={ICONS.close} alt="close" />
                </NavLink>
                <div className="global-container password-reset-content">
                    {hasBeenUpdated ? (
                        <Button className="return-button" mainColor type="primary" linkTo="/profile" typeLink>
                            Return to profile
                        </Button>
                    ) : (
                        <ChangePasswordStep setHasBeenUpdated={setHasBeenUpdated} />
                    )}
                </div>
            </main>
        </>
    )
}

export default observer(ChangePasswordScene)
